import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class InputFocusService {
  private readonly focusTrigger$$ = new Subject<void>();
  readonly focusTrigger$ = this.focusTrigger$$.asObservable();

  dispatchFocus() {
    this.focusTrigger$$.next();
  }
}
